module.exports = new __parcel__URL__("once-upon-a-time-in-hollywood.ffb524f5.jpg").toString();